<template>
  <v-container grid-list-xl>
    <v-card :elevation="2" :loading="loading" :disabled="loading">
      <v-card-title>Recalcular Indicador y avance de PMI</v-card-title>
      <v-alert
        dense
        text
        colored-border
        dismissible
        elevation="2"
        border="left"
        type="warning"
      >
        <v-flex xs12 sm12>
          Seleccione los filtros y haga click en el boton Recalcular, los
          resultados se veran en la parte inferior del formulario
        </v-flex>
      </v-alert>
      <v-layout wrap justify-space-between>
        <v-flex md12 sm12>
          <v-tabs
            show-arrows
            next-icon="fa-caret-right"
            prev-icon="fa-caret-left"
            background-color="blue-grey lighten-4"
            horizontal
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab @click="clearsearch('acumulacion')"> <v-icon left>folder</v-icon>General</v-tab>
            <v-tab @click="clearsearch('indicador')"> <v-icon left>work</v-icon>Por indicador</v-tab>
            <v-tab-item>
              <v-card>
                <v-card-title> </v-card-title>
                <v-card-text>
                  <v-layout wrap justify-space-between>
                    <v-flex md4 sm12>
                      <v-select
                        :items="gtipoacumulacion"
                        v-model="TipoAcumulacion"
                        item-text="nombre"
                        item-value="idtipoacumulacion"
                        clearable
                        class="mx-2"
                        label="Tipo de Acumulación:"
                        :disabled="Allindicadores == true"
                      ></v-select>
                    </v-flex>
                    <v-flex md4 sm12>
                      <v-checkbox
                        class="mx-2" v-model="Indicadoresaprobados"
                        label="Indicadores Aprobados"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex md4 sm12>
                      <v-checkbox
                        class="mx-2" v-model="Allindicadores"
                        label="Todos los indicadores"
                        :disabled="TipoAcumulacion != null"
                      ></v-checkbox>
                    </v-flex>                    
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-layout wrap justify-space-between>
                <v-flex md12 sm12>
                  <v-card>
                    <v-card-title>
                      <v-flex>
                        <v-text-field
                          v-model="search"
                          append-icon="search"
                          label="Buscar"
                          single-line
                          hide-details
                        ></v-text-field>
                      </v-flex>
                    </v-card-title>
                    <v-card-text v-if="gindicadores != null">
                      <v-data-table
                        :headers="headerIndicador"
                        v-model="IndicadorSelected"
                        :items="gindicadores"
                        class="elevation-1"
                        :search="search"
                        :no-data-text="gnodata"
                        :no-results-text="gnosearch"
                        :items-per-page="3"
                        item-key="codigo"
                        show-select
                      >
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>
          </v-tabs>
        </v-flex>
        <v-flex md12 sm12>
          <v-btn color="primary" class="mx-2" style="width: -webkit-fill-available;" @click="calcularavances">Recalcular PMI</v-btn>
        </v-flex>
        <v-flex md12 sm12>
          <v-card>
            <v-card-text max-width="500px">
                <div v-html="MensajeRetorno"></div>
            </v-card-text>
          </v-card>
          
        </v-flex>        
      </v-layout>
    </v-card>

    <v-snackbar v-model="snack1" :timeout="8000" :color="MesaggeInfo.color" >       
      {{ this.MesaggeInfo.mensajeRespuesta }} {{this.MesaggeInfo.codigoRespuesta}}
      <v-btn text @click="snack1 = false">Cerrar</v-btn>
    </v-snackbar>

  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "recalculoPMI",
  data() {
    return {
      loading: false,
      snack1: false,
      tipo: 'acumulacion',
      singleSelect: false,
      TipoAcumulacion: null,
      Indicadoresaprobados: false,
      Allindicadores: false,
      MensajeRetorno: "",
      IndicadorSelected: [],
      headerIndicador: [
        { text: "ID", value: "idindicador", align: " d-none" },
        { value: "codigo", text: "Codigo" },
        { value: "nombre", text: "Nombre" },
      ],
      MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],
      search: "",
    };
  },
  methods: {
    ...mapActions(["get_indicadores"
        , "Gettipoacumulacion"
        , "get_RecalcularPMIGeneral"
        , "get_RecalcularPMIporAcumulacion"
        , "get_RecalcularPMIporindicador"]),
    calcularavances() {
      this.MensajeRetorno = "";
      if (this.tipo == 'acumulacion')
      {
        if (this.Allindicadores == true)
        {
          this.get_RecalcularPMIGeneral({params: {idestado: (this.Indicadoresaprobados == false) ? 1 : 6 }});
          this.loading = true;
          return;
        }
        if (this.TipoAcumulacion != null)
        {
          this.get_RecalcularPMIporAcumulacion({params: {idacumulacion: this.TipoAcumulacion,  idestado: (this.Indicadoresaprobados == false) ? 1 : 6 }});
          this.loading = true;
          return;
        }
          this.MesaggeInfo.mensajeRespuesta = "Debe seleccionar un filtro  para especificar el tipo de calculo a realizar";
          this.MesaggeInfo.color = "warnvue";
          this.snack1 = true;        
      } else if (this.tipo == 'indicador') {
        if (this.IndicadorSelected.length == 0 )
        {
          this.MesaggeInfo.mensajeRespuesta = "Debe seleccionar los indicadores a recalcular";
          this.MesaggeInfo.color = "warnvue";
          this.snack1 = true;
          return;
        } else {
          console.log('Entro a recalculos los indicadores', this.IndicadorSelected.length)
          this.get_RecalcularPMIporindicador({data: this.IndicadorSelected })
          this.loading = true;
          //this.get_RecalcularPMIporindicador({params: {idacumulacion: this.IndicadorSelected  }});
          return;          
        }
      }

    },
    clearsearch(item) {
      this.tipo = item;
      this.TipoAcumulacion = null;
      this.Indicadoresaprobados = false;
      this.Allindicadores = false;
      this.MensajeRetorno = "";
      this.IndicadorSelected = [];
    }
  },
  computed: {
    ...mapGetters("mensaje", ["ginformation", "gnodata", "gnosearch"]),
    ...mapGetters(["gtipoacumulacion", "gindicadores", "gindicadoresmensaje"]),
  },
  created() {
    this.Gettipoacumulacion();
    this.get_indicadores();
  },
  watch: {
    gindicadoresmensaje() { 
      if (this.gindicadoresmensaje.length > 0)
      {
        this.loading = false;
        this.MensajeRetorno = this.gindicadoresmensaje; 
      }
    }
  }
};
</script>

<style>
.Tamanodiv {
  height: 80px;
}
</style>
